import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

import { ModuleViews } from 'app/shared/model/module-views.enum';
import { TeamService } from 'app/shared/service/team.service';
import { UIComponentsTheme } from 'app/ui-components/ui-components-theme.enum';

@Component({
  selector: 'cc-charts-list-toolbar',
  templateUrl: './charts-list-toolbar.component.html',
  styleUrls: [
    '../../../../../styles/components/tool-bar.component.scss',
    './charts-list-toolbar.component.scss',
  ],
})
export class ChartsListToolbarComponent implements OnInit {
  private readonly unSubscribe = new Subject<void>();

  @Input() selectedCharts;
  @Input() dashboard;
  @Input() charts;

  @Output() deleteSelected = new EventEmitter();
  @Output() addChart = new EventEmitter();

  view: ModuleViews;
  moduleViews = ModuleViews;
  teamId: string;
  companyId: string;

  readonly stateToggleTheme = UIComponentsTheme.Grey2;

  constructor(private readonly activatedRoute: ActivatedRoute, private readonly teamService: TeamService) {}

  ngOnInit() {
    const { data, paramMap } = this.activatedRoute.snapshot;

    this.view = data.view;

    this.teamId = paramMap.get('teamId');
    this.companyId = paramMap.get('companyId');

    if (!this.companyId) {
      this.teamService
        .getCompanyId(this.teamId)
        .pipe(takeUntil(this.unSubscribe))
        .subscribe((companyId) => {
          this.companyId = companyId;
        });
    }
  }
}
